module.exports = __webpack_public_path__ + "img/add_2.6f6a2ed7.png";